export const routes = {
    "/:taskId/immunisationCertificate": {
        title: "Immunisation Clear Certificate"
    },
    "/:taskId/allImmunisationsCompletedForRoleCertificate": {
        title: "All Immunisations Completed For Role Certificate"
    }
};
